import { IconAction } from '@tkww/orion-web-ds-action';
import { ProgressBar } from '@tkww/orion-web-ds-feedback';
import { compose } from '@xo-union/react-css-modules';
import React from 'react';
import Styles from './styles.scss';

interface EstimateFormModalHeaderProps {
	currentStep: number;
	totalSteps: number;
	showBack?: boolean;
	showProgress?: boolean;
	onBack: () => void;
	onClose: () => void;
}

export const EstimateFormModalHeader = ({
	currentStep,
	totalSteps,
	showBack = false,
	showProgress = true,
	onBack,
	onClose,
}: EstimateFormModalHeaderProps) => (
	<div className={Styles.modalHeader} data-testid="estimate-form-modal-header">
		<div className={Styles.headerActions}>
			{showBack && (
				<IconAction
					className={Styles.backButton}
					name="arrow-left"
					size="md"
					onClick={onBack}
					aria-label="Go back"
					data-testid="estimate-form-back-button"
				/>
			)}
			<IconAction
				name="close"
				size="md"
				onClick={onClose}
				aria-label="Close modal"
				data-testid="estimate-form-close-button"
			/>
		</div>
		{showProgress && (
			<ProgressBar
				role="progressbar"
				aria-label={`Step ${currentStep} of ${totalSteps}`}
				aria-valuemin={0}
				aria-valuenow={currentStep}
				aria-valuemax={totalSteps}
				min={0}
				value={currentStep}
				max={totalSteps}
				classes={compose({ wrapper: Styles.progressBarWrapper })}
				data-testid="estimate-form-progress-indicator"
			/>
		)}
	</div>
);
